import { useState, useEffect, useRef, useCallback } from "react";
import { THEMES, searchWikipedia } from "./wikiAPI";

// ── MASSIVE RANDOM FACTS POOL ────────────────
const ALL_FACTS = [
  "The shortest war in history lasted only 38 to 45 minutes.",
  "A day on Venus is longer than a year on Venus.",
  "Cleopatra lived closer in time to the Moon landing than to the construction of the Great Pyramid.",
  "Oxford University is older than the Aztec Empire.",
  "The woolly mammoth was still alive when the Great Pyramid was being built.",
  "There are more possible chess games than atoms in the observable universe.",
  "Nintendo was founded in 1889, originally as a playing card company.",
  "The fax machine was invented before the telephone.",
  "Scotland's national animal is the unicorn.",
  "A group of flamingos is called a flamboyance.",
  "Honey never spoils — archaeologists found 3,000-year-old honey in Egyptian tombs.",
  "The Great Wall of China is not visible from space with the naked eye.",
  "Bananas are berries, but strawberries are not.",
  "A bolt of lightning is five times hotter than the surface of the sun.",
  "The human brain uses about 20% of the body's total energy.",
  "Octopuses have three hearts and blue blood.",
  "The Eiffel Tower grows about 6 inches taller in summer due to heat expansion.",
  "There are more stars in the universe than grains of sand on Earth's beaches.",
  "Wombats produce cube-shaped droppings — the only known animal to do so.",
  "The average person walks about 100,000 miles in their lifetime.",
  "A snail can sleep for up to three years.",
  "The shortest commercial flight in the world lasts about 57 seconds.",
  "Crows can recognize and remember human faces.",
  "The world's oldest known living tree is over 5,000 years old.",
  "Sharks are older than trees — they've existed for over 400 million years.",
  "It would take about 70,000 years to reach the nearest star at current spacecraft speeds.",
  "The human body contains enough carbon to make about 9,000 pencils.",
  "Penguins propose to their mates by giving them a pebble.",
  "A day on Mars is 24 hours and 37 minutes.",
  "The first computer bug was an actual bug — a moth found in a computer in 1947.",
  "Butterflies taste with their feet.",
  "An octopus can edit its own RNA to adapt to cold temperatures.",
  "There are more possible iterations of a game of chess than atoms in the universe.",
  "The loudest animal on Earth is the sperm whale.",
  "Mosquitoes are the deadliest animals on Earth, killing more humans than any other animal.",
  "A day on Pluto lasts about 6.4 Earth days.",
  "The shortest complete sentence in English is 'Go.'",
  "Tardigrades can survive in the vacuum of space.",
  "Cats have a dedicated meow just for communicating with humans.",
  "The speed of light is approximately 186,000 miles per second.",
  "Marie Curie is the only person to win Nobel Prizes in two different sciences.",
  "The Amazon rainforest produces 20% of the world's oxygen.",
  "Elephants are the only animals that can't jump.",
  "A group of owls is called a parliament.",
  "The human eye can distinguish about 10 million different colors.",
  "Sloths can hold their breath for up to 40 minutes.",
  "The first email was sent in 1971 by Ray Tomlinson.",
  "Alaska is simultaneously the westernmost and easternmost state in the US.",
  "The world's largest desert is Antarctica, not the Sahara.",
  "Humans share 60% of their DNA with bananas.",
  "There are more bicycles in the Netherlands than people.",
  "The average cloud weighs about 1.1 million pounds.",
  "Lightning strikes the Earth about 100 times every second.",
  "The Pacific Ocean is larger than all of Earth's landmass combined.",
  "A year on Mercury lasts just 88 Earth days.",
  "The world's oldest university, Bologna, was founded in 1088.",
  "Polar bears have black skin under their white fur.",
  "The tongue is the fastest healing organ in the human body.",
  "A group of porcupines is called a prickle.",
  "The first product to have a barcode scanned was a pack of Wrigley's gum.",
  "Glass is technically a supercooled liquid, not a solid.",
  "The average person spends 6 months of their lifetime waiting at red lights.",
  "There are more fake flamingos in the world than real ones.",
  "The violin has about 70 separate pieces of wood in its construction.",
  "All the gold ever mined would fit in about 3.5 Olympic-size swimming pools.",
  "The fingerprints of a koala are virtually indistinguishable from human fingerprints.",
  "A single strand of spaghetti is called a spaghetto.",
  "The first oranges weren't orange — they were green.",
  "Cows have best friends and get stressed when separated from them.",
  "The world's largest snowflake on record was 15 inches wide.",
  "Bats always turn left when exiting a cave.",
  "A shrimp's heart is located in its head.",
  "The average human body has 37.2 trillion cells.",
  "It rains diamonds on Neptune and Uranus.",
  "An individual blood cell makes a full circuit of the body in about 60 seconds.",
  "Hummingbirds are the only birds that can fly backwards.",
  "The average person produces enough saliva in their lifetime to fill two swimming pools.",
  "Crickets hear through their knees.",
  "The brain is the only organ that named itself.",
  "The oldest known joke dates back to 1900 BC in ancient Sumeria.",
  "A group of cats is called a clowder.",
  "The word 'nerd' was first coined by Dr. Seuss in 1950.",
  "Apples are more effective at waking you up than coffee.",
  "Every time you shuffle a deck of cards, you get an order never seen before in history.",
  "The original name for the search engine Google was BackRub.",
  "There are 43 quintillion possible configurations of a Rubik's Cube.",
  "The strongest muscle in the human body relative to its size is the masseter (jaw muscle).",
  "Crows hold grudges and will remember the face of someone who wronged them.",
  "The inventor of the Pringles can is buried in one.",
  "A group of jellyfish is called a smack.",
  "Humans are the only animals that blush.",
  "The 'sixth sick sheik's sixth sheep's sick' is considered the hardest tongue twister.",
  "Canada has the longest coastline of any country in the world.",
  "The Eiffel Tower was supposed to be demolished after 20 years.",
  "A jiffy is an actual unit of time: 1/100th of a second.",
  "Goats have rectangular pupils to give them a wider field of vision.",
  "The hashtag symbol (#) is officially called an octothorpe.",
  "A group of hippos is called a bloat.",
  "Humans and giraffes have the same number of neck vertebrae: seven.",
  "The smell of rain has a name — petrichor.",
  "The longest word in the English language takes 3.5 hours to pronounce.",
  "Cats can't taste sweet things.",
];

const DIFFICULTIES = [
  {
    id:"scholar", label:"Scholar", color:"#4ade80",
    pages: 4, hints:"3 hints per page (progressive)",
    desc:"4 pages · Famous topics · Obvious anomaly",
    example:'e.g. "born in Antarctica" or "succeeded by Mickey Mouse"',
    badge:"EASY",
  },
  {
    id:"detective", label:"Detective", color:"#facc15",
    pages: 6, hints:"1 hint per page",
    desc:"6 pages · Mixed topics · Plausible wrong fact",
    example:'e.g. "France" used instead of "Germany" — clearly off if you know the subject',
    badge:"MEDIUM",
  },
  {
    id:"oracle", label:"Oracle", color:"#f87171",
    pages: 9, hints:"No hints",
    desc:"9 pages · Any topic · Near-invisible anomaly",
    example:'e.g. year off by 1, neighboring city — requires real scrutiny',
    badge:"HARD",
  },
];

const SETTINGS_CONFIG = [
  { id:"timer",         label:"Show Timer",            type:"toggle", default:true  },
  { id:"clickCount",    label:"Show Click Count",      type:"toggle", default:true  },
  { id:"breadcrumb",    label:"Show Breadcrumb Trail", type:"toggle", default:true  },
  { id:"floatingFacts", label:"Floating Background Facts", type:"toggle", default:true  },
  { id:"factSpeed",     label:"Fact Speed",            type:"slider", default:3, min:1, max:5 },
];

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&family=Crimson+Pro:wght@400;600&family=Space+Mono:wght@400;700&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
  :root{
    --bg:#0a0a0f;--surface:#12121a;--surface2:#1a1a26;
    --border:rgba(255,255,255,0.08);--gold:#d4a94a;--gold-lt:#f0cc7a;
    --gold-dim:rgba(212,169,74,0.15);--text:#e8e4d8;--muted:#6b6880;--radius:6px;
  }
  html,body,#root{height:100%;background:var(--bg);overflow:hidden;}
  body{font-family:'Crimson Pro',Georgia,serif;color:var(--text);}

  /* height:100vh + overflow:hidden = guaranteed single screen, no scroll */
  .start-root{position:relative;height:100vh;overflow:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0.4rem 1rem;}
  .bg-grid{position:absolute;inset:0;pointer-events:none;background-image:linear-gradient(rgba(212,169,74,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(212,169,74,0.04) 1px,transparent 1px);background-size:48px 48px;}
  .facts-layer{position:absolute;inset:0;pointer-events:none;overflow:hidden;}
  .fact-bubble{position:absolute;font-family:'Space Mono',monospace;font-size:0.63rem;color:rgba(212,169,74,0.28);max-width:190px;line-height:1.4;text-align:center;padding:5px 8px;border:1px solid rgba(212,169,74,0.1);border-radius:4px;background:rgba(10,10,15,0.5);animation:floatUp linear infinite;}
  @keyframes floatUp{0%{transform:translateY(110vh);opacity:0;}8%{opacity:1;}92%{opacity:1;}100%{transform:translateY(-15vh);opacity:0;}}

  .title-block{text-align:center;position:relative;z-index:2;width:100%;max-width:580px;}

  /* Globe — slightly smaller to save vertical space */
  .globe-wrap{position:relative;width:68px;height:68px;margin:0 auto 0.55rem;display:flex;align-items:center;justify-content:center;}
  .wiki-globe{width:60px;height:60px;border-radius:50%;background:radial-gradient(circle at 38% 36%,#1e1e30,#0a0a0f);border:2px solid var(--gold);display:flex;align-items:center;justify-content:center;font-size:2.1rem;animation:globePulse 4s ease-in-out infinite;box-shadow:0 0 40px rgba(212,169,74,0.25),0 0 80px rgba(212,169,74,0.1);position:relative;z-index:1;}
  @keyframes globePulse{0%,100%{box-shadow:0 0 30px rgba(212,169,74,0.25),0 0 60px rgba(212,169,74,0.08);}50%{box-shadow:0 0 55px rgba(212,169,74,0.55),0 0 100px rgba(212,169,74,0.2);}}
  .sparkle{position:absolute;border-radius:50%;background:var(--gold);pointer-events:none;}
  .sparkle-1{width:5px;height:5px;top:-4px;left:50%;transform:translateX(-50%);animation:twinkle1 2.1s ease-in-out infinite;}
  .sparkle-2{width:4px;height:4px;top:10%;right:-4px;animation:twinkle2 2.7s ease-in-out infinite 0.4s;}
  .sparkle-3{width:3px;height:3px;bottom:8%;right:0%;animation:twinkle1 3.1s ease-in-out infinite 0.9s;}
  .sparkle-4{width:4px;height:4px;bottom:-3px;left:30%;animation:twinkle2 2.4s ease-in-out infinite 1.2s;}
  .sparkle-5{width:3px;height:3px;top:20%;left:-4px;animation:twinkle1 2.8s ease-in-out infinite 0.6s;}
  .sparkle-6{width:5px;height:5px;top:50%;right:-5px;transform:translateY(-50%);animation:twinkle2 2.2s ease-in-out infinite 1.5s;}
  @keyframes twinkle1{0%,100%{opacity:0;transform:scale(0.4) translateX(-50%);}45%{opacity:1;transform:scale(1.2) translateX(-50%);}}
  @keyframes twinkle2{0%,100%{opacity:0;transform:scale(0.3);}50%{opacity:1;transform:scale(1.3);}}

  .eyebrow{font-family:'Space Mono',monospace;font-size:0.6rem;letter-spacing:0.3em;text-transform:uppercase;color:var(--muted);margin-bottom:0.12rem;}
  .title-main{font-family:'Cinzel',serif;font-size:clamp(2rem,6vw,3.8rem);font-weight:900;line-height:0.88;color:var(--gold-lt);text-transform:uppercase;text-shadow:0 0 60px rgba(212,169,74,0.3);}
  .title-main span{color:var(--text);opacity:0.85;}
  .title-sub{font-family:'Space Mono',monospace;font-size:0.65rem;letter-spacing:0.18em;color:var(--muted);margin-top:0.22rem;text-transform:uppercase;}

  /* Section labels — tight margins so the whole page fits */
  .section-label{font-family:'Space Mono',monospace;font-size:0.58rem;letter-spacing:0.22em;text-transform:uppercase;color:var(--muted);margin:0.6rem 0 0.28rem;text-align:center;}

  .theme-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;width:100%;}
  .theme-btn{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:0.42rem 0.4rem;cursor:pointer;text-align:center;transition:all 0.15s;}
  .theme-btn:hover{border-color:rgba(255,255,255,0.2);transform:translateY(-2px);}
  .theme-btn.active{border-color:var(--gold);background:var(--gold-dim);transform:translateY(-2px);}
  .theme-emoji{font-size:1.1rem;display:block;margin-bottom:0.18rem;}
  .theme-label{font-family:'Space Mono',monospace;font-size:0.6rem;color:var(--text);letter-spacing:0.04em;}

  /* Custom search */
  .custom-search-wrap{position:relative;margin-top:0.3rem;width:100%;}
  .custom-input{width:100%;background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:0.52rem 0.85rem;font-family:'Space Mono',monospace;font-size:0.75rem;color:var(--text);outline:none;transition:border-color 0.15s;}
  .custom-input:focus{border-color:var(--gold);}
  .custom-input::placeholder{color:var(--muted);}
  .search-dropdown{position:absolute;top:calc(100% + 4px);left:0;right:0;background:var(--surface2);border:1px solid var(--border);border-radius:var(--radius);z-index:50;overflow:hidden;}
  .search-item{padding:0.55rem 0.85rem;font-family:'Space Mono',monospace;font-size:0.72rem;color:var(--text);cursor:pointer;transition:background 0.1s;border-bottom:1px solid var(--border);}
  .search-item:last-child{border-bottom:none;}
  .search-item:hover{background:var(--gold-dim);color:var(--gold-lt);}
  .search-item.selected{background:var(--gold-dim);color:var(--gold);}
  .search-loading{padding:0.55rem 0.85rem;font-family:'Space Mono',monospace;font-size:0.7rem;color:var(--muted);}

  .diff-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;width:100%;}
  .diff-btn{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:0.52rem 0.4rem 0.48rem;cursor:pointer;text-align:center;transition:all 0.15s;position:relative;}
  .diff-btn:hover{transform:translateY(-2px);border-color:rgba(255,255,255,0.18);}
  .diff-btn.active{transform:translateY(-3px);}
  .diff-badge{position:absolute;top:5px;right:5px;font-family:'Space Mono',monospace;font-size:0.42rem;letter-spacing:0.1em;padding:1px 4px;border-radius:3px;opacity:0.7;}
  .diff-dot{width:8px;height:8px;border-radius:50%;margin:0 auto 0.22rem;}
  .diff-name{font-family:'Cinzel',serif;font-size:0.76rem;font-weight:700;display:block;margin-bottom:0.14rem;}
  .diff-desc{font-family:'Space Mono',monospace;font-size:0.54rem;color:var(--muted);display:block;line-height:1.3;}
  .diff-hints{font-family:'Space Mono',monospace;font-size:0.56rem;margin-top:0.15rem;display:block;opacity:0.55;}
  .custom-pages-row{display:flex;align-items:center;gap:0.75rem;margin-top:0.3rem;justify-content:center;flex-wrap:wrap;}
  .custom-pages-label{font-family:'Space Mono',monospace;font-size:0.62rem;color:var(--muted);}
  .custom-pages-input{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:0.3rem 0.6rem;font-family:'Space Mono',monospace;font-size:0.75rem;color:var(--text);outline:none;width:72px;text-align:center;transition:border-color 0.15s;}
  .custom-pages-input:focus{border-color:var(--gold);}
  .custom-pages-input::placeholder{color:var(--muted);}
  .start-section-divider{width:100%;border:none;border-top:1px solid var(--border);margin:0.15rem 0;}

  .btn-row{display:flex;gap:10px;margin-top:0.6rem;flex-wrap:wrap;justify-content:center;}
  .btn{font-family:'Cinzel',serif;font-size:0.76rem;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;border:none;cursor:pointer;border-radius:var(--radius);transition:all 0.15s;padding:0.65rem 1.2rem;}
  .btn:hover{transform:translateY(-2px);filter:brightness(1.1);}
  .btn:active{transform:translateY(1px);filter:brightness(0.9);}
  .btn-primary{background:var(--gold);color:#0a0a0f;box-shadow:0 4px 24px rgba(212,169,74,0.35);font-size:0.86rem;padding:0.8rem 2.2rem;}
  .btn-primary:disabled{opacity:0.5;cursor:not-allowed;transform:none;}
  .btn-secondary{background:var(--surface2);color:var(--text);border:1px solid var(--border);}

  .overlay-backdrop{position:fixed;inset:0;background:rgba(0,0,0,0.78);z-index:100;display:flex;align-items:center;justify-content:center;padding:1.5rem;animation:fadeIn 0.2s ease;}
  @keyframes fadeIn{from{opacity:0}to{opacity:1}}
  .overlay-panel{background:var(--surface);border:1px solid rgba(212,169,74,0.22);border-radius:10px;width:100%;max-width:500px;max-height:84vh;overflow-y:auto;animation:slideUp 0.2s ease;}
  /* Settings overlay still uses the class version — Rules uses inline styles */
  @keyframes slideUp{from{transform:translateY(14px);opacity:0}to{transform:translateY(0);opacity:1}}
  .overlay-header{display:flex;align-items:center;justify-content:space-between;padding:1.05rem 1.35rem 0.85rem;border-bottom:1px solid var(--border);position:sticky;top:0;background:var(--surface);z-index:1;}
  .overlay-title{font-family:'Cinzel',serif;font-size:0.98rem;font-weight:700;color:var(--gold-lt);}
  .btn-close{background:none;border:1px solid var(--border);color:var(--muted);border-radius:4px;width:27px;height:27px;cursor:pointer;font-size:0.85rem;display:flex;align-items:center;justify-content:center;transition:all 0.15s;}
  .btn-close:hover{border-color:var(--gold);color:var(--gold);}
  .overlay-body{padding:1.05rem 1.35rem;}
  .rules-section{margin-bottom:1.3rem;}
  .rules-section h3{font-family:'Cinzel',serif;font-size:0.7rem;letter-spacing:0.14em;text-transform:uppercase;color:var(--gold);margin-bottom:0.5rem;padding-bottom:0.3rem;border-bottom:1px solid var(--border);}
  .rules-section p,.rules-section li{font-size:0.9rem;line-height:1.65;color:rgba(232,228,216,0.82);}
  .rules-section ol,.rules-section ul{padding-left:1.2rem;display:flex;flex-direction:column;gap:0.28rem;}
  .rule-highlight{background:var(--gold-dim);border-left:3px solid var(--gold);border-radius:0 4px 4px 0;padding:0.5rem 0.75rem;font-family:'Space Mono',monospace;font-size:0.7rem;color:var(--gold-lt);margin-top:0.45rem;line-height:1.5;}
  .setting-row{display:flex;align-items:center;justify-content:space-between;padding:0.75rem 0;border-bottom:1px solid var(--border);gap:1rem;}
  .setting-row:last-child{border-bottom:none;}
  .setting-label{font-size:0.9rem;color:var(--text);}
  .toggle-wrap{position:relative;width:40px;height:22px;flex-shrink:0;}
  .toggle-wrap input{opacity:0;width:0;height:0;position:absolute;}
  .toggle-track{position:absolute;inset:0;border-radius:22px;background:var(--surface2);border:1px solid var(--border);cursor:pointer;transition:background 0.2s,border-color 0.2s;}
  .toggle-track::after{content:'';position:absolute;left:3px;top:50%;transform:translateY(-50%);width:14px;height:14px;border-radius:50%;background:var(--muted);transition:left 0.2s,background 0.2s;}
  .toggle-wrap input:checked+.toggle-track{background:var(--gold-dim);border-color:var(--gold);}
  .toggle-wrap input:checked+.toggle-track::after{left:19px;background:var(--gold);}
  .setting-slider{display:flex;align-items:center;gap:8px;}
  .setting-slider input[type=range]{width:88px;accent-color:var(--gold);cursor:pointer;}
  .slider-val{font-family:'Space Mono',monospace;font-size:0.7rem;color:var(--gold);min-width:14px;}
  .overlay-panel::-webkit-scrollbar{width:3px;}
  .overlay-panel::-webkit-scrollbar-thumb{background:var(--border);border-radius:3px;}
`;

// ── Floating Facts ─────────────────────────
function FloatingFacts({ speed = 3, enabled = true }) {
  const COUNT = 8;
  const items = useRef(
    Array.from({ length: COUNT }, (_, i) => {
      // Pick unique random facts
      const idx = Math.floor(Math.random() * ALL_FACTS.length);
      return {
        fact: ALL_FACTS[idx],
        left: `${4 + (i / COUNT) * 90}%`,
        delay: `${(i / COUNT) * -34}s`,
        duration: `${28 + Math.random() * 20}s`,
        id: i,
      };
    })
  );
  if (!enabled) return null;
  return (
    <div className="facts-layer">
      {items.current.map((f) => (
        <div key={f.id} className="fact-bubble" style={{
          left: f.left,
          animationDuration: `${parseFloat(f.duration) / speed}s`,
          animationDelay: f.delay,
        }}>
          {f.fact}
        </div>
      ))}
    </div>
  );
}

// ── Wikipedia Search Dropdown ──────────────
function WikiSearch({ value, onSelect }) {
  const [query,    setQuery]    = useState(value || "");
  const [results,  setResults]  = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [open,     setOpen]     = useState(false);
  const [selected, setSelected] = useState(value || "");
  const debounce = useRef(null);

  const doSearch = useCallback(async (q) => {
    if (q.trim().length < 2) { setResults([]); setOpen(false); return; }
    setLoading(true);
    try {
      const res = await searchWikipedia(q);
      setResults(res);
      setOpen(res.length > 0);
    } finally {
      setLoading(false);
    }
  }, []);

  function handleChange(e) {
    const q = e.target.value;
    setQuery(q);
    setSelected("");
    onSelect("");
    clearTimeout(debounce.current);
    debounce.current = setTimeout(() => doSearch(q), 320);
  }

  function handlePick(title) {
    setQuery(title);
    setSelected(title);
    onSelect(title);
    setOpen(false);
    setResults([]);
  }

  return (
    <div className="custom-search-wrap">
      <input
        className="custom-input"
        placeholder="Search Wikipedia articles…"
        value={query}
        onChange={handleChange}
        onFocus={() => results.length > 0 && setOpen(true)}
      />
      {selected && (
        <div style={{ fontFamily:"'Space Mono',monospace", fontSize:"0.62rem", color:"#4ade80", marginTop:"0.3rem", paddingLeft:"0.2rem" }}>
          ✓ Selected: {selected}
        </div>
      )}
      {(open || loading) && (
        <div className="search-dropdown">
          {loading && <div className="search-loading">Searching…</div>}
          {!loading && results.map((r) => (
            <div key={r} className={`search-item ${r === selected ? "selected" : ""}`} onClick={() => handlePick(r)}>
              {r}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Rules Overlay ──────────────────────────
function RulesOverlay({ onClose }) {
  const S = {
    backdrop: {
      position:"fixed", inset:0, background:"rgba(0,0,0,0.82)", zIndex:100,
      display:"flex", alignItems:"center", justifyContent:"center",
      padding:"1rem", animation:"fadeIn 0.2s ease",
    },
    panel: {
      background:"#12121a", border:"1px solid rgba(212,169,74,0.25)",
      borderRadius:12, width:"100%", maxWidth:520,
      overflow:"hidden", animation:"slideUp 0.2s ease",
      display:"flex", flexDirection:"column",
    },
    header: {
      display:"flex", alignItems:"center", justifyContent:"space-between",
      padding:"0.9rem 1.2rem 0.75rem",
      borderBottom:"1px solid rgba(255,255,255,0.07)",
    },
    titleWrap: { display:"flex", alignItems:"center", gap:"0.5rem" },
    globeIcon: { fontSize:"1.1rem", filter:"drop-shadow(0 0 6px rgba(212,169,74,0.5))" },
    title: {
      fontFamily:"'Cinzel',serif", fontSize:"0.95rem",
      fontWeight:700, color:"#f0cc7a", letterSpacing:"0.05em",
    },
    closeBtn: {
      background:"none", border:"1px solid rgba(255,255,255,0.1)",
      color:"#6b6880", borderRadius:4, width:26, height:26,
      cursor:"pointer", fontSize:"0.8rem", display:"flex",
      alignItems:"center", justifyContent:"center", transition:"all 0.15s",
    },
    body: { padding:"0.9rem 1.2rem", display:"flex", flexDirection:"column", gap:"0.75rem" },

    // goal block
    goalBox: {
      background:"rgba(212,169,74,0.07)", border:"1px solid rgba(212,169,74,0.18)",
      borderRadius:8, padding:"0.65rem 0.9rem", textAlign:"center",
    },
    goalText: {
      fontFamily:"'Crimson Pro',Georgia,serif", fontSize:"0.98rem",
      color:"#e8e4d8", lineHeight:1.5, margin:0,
    },
    goalEm: { color:"#f0cc7a", fontWeight:600, fontStyle:"normal" },

    // section label
    sectionLabel: {
      fontFamily:"'Space Mono',monospace", fontSize:"0.48rem",
      letterSpacing:"0.22em", textTransform:"uppercase",
      color:"#6b6880", marginBottom:"0.35rem",
    },

    // steps row
    stepsRow: { display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"0.5rem" },
    stepCard: {
      background:"#1a1a26", border:"1px solid rgba(255,255,255,0.07)",
      borderRadius:7, padding:"0.6rem 0.5rem", textAlign:"center",
    },
    stepNum: {
      width:22, height:22, borderRadius:"50%",
      background:"rgba(212,169,74,0.15)", border:"1px solid rgba(212,169,74,0.4)",
      fontFamily:"'Cinzel',serif", fontSize:"0.65rem", color:"#d4a94a",
      display:"flex", alignItems:"center", justifyContent:"center",
      margin:"0 auto 0.4rem",
    },
    stepEmoji: { fontSize:"1.1rem", display:"block", marginBottom:"0.25rem" },
    stepTitle: {
      fontFamily:"'Cinzel',serif", fontSize:"0.58rem", color:"#e8e4d8",
      letterSpacing:"0.04em", display:"block", marginBottom:"0.2rem",
    },
    stepDesc: {
      fontFamily:"'Crimson Pro',Georgia,serif", fontSize:"0.75rem",
      color:"#6b6880", lineHeight:1.35,
    },

    // anomaly types
    typesRow: { display:"flex", gap:"0.4rem", flexWrap:"wrap" },
    typePill: {
      background:"rgba(212,169,74,0.08)", border:"1px solid rgba(212,169,74,0.22)",
      borderRadius:5, padding:"0.3rem 0.55rem",
      fontFamily:"'Space Mono',monospace", fontSize:"0.58rem",
      color:"#d4a94a", whiteSpace:"nowrap",
    },
    warnPill: {
      background:"rgba(248,113,113,0.07)", border:"1px solid rgba(248,113,113,0.2)",
      borderRadius:5, padding:"0.3rem 0.55rem",
      fontFamily:"'Space Mono',monospace", fontSize:"0.55rem",
      color:"rgba(248,113,113,0.75)", whiteSpace:"nowrap",
    },

    // difficulty cards
    diffRow: { display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"0.5rem" },
    diffCard: (color, bg) => ({
      background: bg, border:`1px solid ${color}30`,
      borderRadius:7, padding:"0.6rem 0.5rem", textAlign:"center",
    }),
    diffName: (color) => ({
      fontFamily:"'Cinzel',serif", fontSize:"0.68rem", fontWeight:700,
      color, display:"block", marginBottom:"0.3rem",
    }),
    diffStat: {
      fontFamily:"'Space Mono',monospace", fontSize:"0.52rem",
      color:"rgba(232,228,216,0.5)", lineHeight:1.6,
    },

    // score note
    scoreNote: {
      textAlign:"center", fontFamily:"'Space Mono',monospace",
      fontSize:"0.52rem", color:"#6b6880", letterSpacing:"0.06em",
      paddingTop:"0.1rem",
    },
  };

  return (
    <div style={S.backdrop} onClick={onClose}>
      <div style={S.panel} onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div style={S.header}>
          <div style={S.titleWrap}>
            <span style={S.globeIcon}>🌐</span>
            <span style={S.title}>How to Play</span>
          </div>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div style={S.body}>

          {/* Goal */}
          <div style={S.goalBox}>
            <p style={S.goalText}>
              Each Wikipedia article hides one fake fact — the{" "}
              <em style={S.goalEm}>anomaly</em>. It's always a{" "}
              <em style={S.goalEm}>clickable link</em>. Find it, click it,{" "}
              advance to the next article. Complete all pages to win.
            </p>
          </div>

          {/* Steps */}
          <div>
            <div style={S.sectionLabel}>How it works</div>
            <div style={S.stepsRow}>
              {[
                { n:"1", emoji:"📖", title:"Read", desc:"Scan the article for something that feels off" },
                { n:"2", emoji:"🖱️", title:"Click", desc:"Click the wrong fact — it's a blue hyperlink" },
                { n:"3", emoji:"⚡", title:"Advance", desc:"Correct = green flash + next article loads" },
              ].map(({ n, emoji, title, desc }) => (
                <div key={n} style={S.stepCard}>
                  <div style={S.stepNum}>{n}</div>
                  <span style={S.stepEmoji}>{emoji}</span>
                  <span style={S.stepTitle}>{title}</span>
                  <span style={S.stepDesc}>{desc}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Anomaly types */}
          <div>
            <div style={S.sectionLabel}>The anomaly will be</div>
            <div style={S.typesRow}>
              {["📅 Wrong date","📍 Wrong place","👤 Wrong person","💼 Wrong title"].map(t => (
                <span key={t} style={S.typePill}>{t}</span>
              ))}
              <span style={S.warnPill}>⚠ Other links = wrong click + cooldown</span>
            </div>
          </div>

          {/* Difficulty */}
          <div>
            <div style={S.sectionLabel}>Difficulty</div>
            <div style={S.diffRow}>
              <div style={S.diffCard("#4ade80","rgba(74,222,128,0.05)")}>
                <span style={S.diffName("#4ade80")}>Scholar</span>
                <span style={S.diffStat}>4 pages{"\n"}Hints: unlimited{"\n"}Cooldown: 5s</span>
              </div>
              <div style={S.diffCard("#facc15","rgba(250,204,21,0.05)")}>
                <span style={S.diffName("#facc15")}>Detective</span>
                <span style={S.diffStat}>6 pages{"\n"}Hints: 2 total{"\n"}Cooldown: 10s</span>
              </div>
              <div style={S.diffCard("#f87171","rgba(248,113,113,0.05)")}>
                <span style={S.diffName("#f87171")}>Oracle</span>
                <span style={S.diffStat}>9 pages{"\n"}Hints: none{"\n"}Cooldown: 15s</span>
              </div>
            </div>
          </div>

          {/* Score note */}
          <div style={S.scoreNote}>
            SCORE drops for: time elapsed · wrong clicks · hints used
          </div>

        </div>
      </div>
    </div>
  );
}

// ── Settings Overlay ───────────────────────
function SettingsOverlay({ settings, onChange, onClose }) {
  return (
    <div className="overlay-backdrop" onClick={onClose}>
      <div className="overlay-panel" onClick={(e) => e.stopPropagation()}>
        <div className="overlay-header">
          <span className="overlay-title">Settings</span>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className="overlay-body">
          {SETTINGS_CONFIG.map((cfg) => (
            <div className="setting-row" key={cfg.id}>
              <span className="setting-label">{cfg.label}</span>
              {cfg.type === "toggle" && (
                <label className="toggle-wrap">
                  <input type="checkbox" checked={settings[cfg.id]}
                    onChange={(e) => onChange(cfg.id, e.target.checked)} />
                  <span className="toggle-track" />
                </label>
              )}
              {cfg.type === "slider" && (
                <div className="setting-slider">
                  <input type="range" min={cfg.min} max={cfg.max}
                    value={settings[cfg.id]} step="1"
                    onChange={(e) => onChange(cfg.id, Number(e.target.value))} />
                  <span className="slider-val">{settings[cfg.id]}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── MAIN ──────────────────────────────────
export default function StartScreen({ onStart }) {
  const [theme,       setTheme]      = useState("random");
  const [customPage,  setCustomPage] = useState("");   // "You Choose" theme page
  const [startPage,   setStartPage]  = useState("");   // optional custom starting page (all themes)
  const [customPages, setCustomPages]= useState("");   // optional custom page count
  const [difficulty,  setDifficulty] = useState("detective");
  const [overlay,     setOverlay]    = useState(null);
  const [funMode,     setFunMode]    = useState(false);
  const [settings,    setSettings]   = useState(() =>
    Object.fromEntries(SETTINGS_CONFIG.map((c) => [c.id, c.default]))
  );

  useEffect(() => {
    const tag = document.createElement("style");
    tag.textContent = STYLES;
    document.head.appendChild(tag);
    return () => tag.remove();
  }, []);

  const activeDiff   = DIFFICULTIES.find((d) => d.id === difficulty);
  const defaultPages = activeDiff?.pages ?? 4;
  const parsedCustom = parseInt(customPages, 10);
  const validCustom  = !isNaN(parsedCustom) && parsedCustom >= 1 && parsedCustom <= 20;
  const finalPages   = validCustom ? parsedCustom : defaultPages;

  // canStart: "You Choose" theme requires a customPage; starting page is always optional
  const canStart = theme !== "custom" || customPage.trim().length > 0;

  function handleStart() {
    onStart({
      difficulty,
      settings: { ...settings, funMode },
      theme,
      customPage:  theme === "custom" ? customPage.trim() || null : null,
      startPage:   startPage.trim() || null,
      customPages: validCustom ? parsedCustom : null,
    });
  }

  return (
    <div className="start-root">
      <div className="bg-grid" />
      <FloatingFacts speed={settings.factSpeed} enabled={settings.floatingFacts} />

      <div className="title-block">
        <div className="globe-wrap">
          <div className="wiki-globe">🌐</div>
          <span className="sparkle sparkle-1" />
          <span className="sparkle sparkle-2" />
          <span className="sparkle sparkle-3" />
          <span className="sparkle sparkle-4" />
          <span className="sparkle sparkle-5" />
          <span className="sparkle sparkle-6" />
        </div>
        <p className="eyebrow">Wikipedia Scavenger Hunt</p>
        <h1 className="title-main">Wiki<br /><span>Scav</span></h1>
        <p className="title-sub">Find the Anomaly · Page by Page · Win</p>

        {/* ── Theme ── */}
        <p className="section-label">Choose a Theme</p>
        <div className="theme-grid">
          {Object.entries(THEMES).filter(([id]) => id !== "custom").map(([id, t]) => (
            <button key={id} className={`theme-btn ${theme === id ? "active" : ""}`}
              onClick={() => { setTheme(id); setCustomPage(""); }}
              style={{ position:"relative" }}>
              {id === "random" && (
                <span style={{
                  position:"absolute", top:"4px", right:"4px",
                  fontFamily:"'Space Mono',monospace", fontSize:"0.38rem",
                  letterSpacing:"0.06em", textTransform:"uppercase",
                  background:"rgba(212,169,74,0.18)", color:"var(--gold)",
                  border:"1px solid rgba(212,169,74,0.4)", borderRadius:"3px",
                  padding:"1px 4px", lineHeight:1.4,
                }}>★ default</span>
              )}
              <span className="theme-emoji">{t.emoji}</span>
              <span className="theme-label">{t.label}</span>
            </button>
          ))}
        </div>

        {/* ── Starting Page (optional, all themes) ── */}
        <p className="section-label" style={{ marginTop:"0.5rem" }}>
          Starting Page&nbsp;
          <span style={{ fontFamily:"'Crimson Pro',serif", fontSize:"0.72rem",
            textTransform:"none", letterSpacing:0, color:"rgba(107,104,128,0.7)",
            fontStyle:"italic" }}>
            (optional)
          </span>
        </p>
        <WikiSearch value={startPage} onSelect={setStartPage} />

        {/* ── Difficulty ── */}
        <p className="section-label">Select Difficulty</p>
        <div className="diff-grid">
          {DIFFICULTIES.map((d) => (
            <button key={d.id} className={`diff-btn ${difficulty === d.id ? "active" : ""}`}
              onClick={() => setDifficulty(d.id)}
              style={{
                borderColor: difficulty === d.id ? d.color : undefined,
                boxShadow:   difficulty === d.id ? `0 0 18px ${d.color}28` : undefined,
              }}>
              {/* badge */}
              <span className="diff-badge"
                style={{ background:`${d.color}18`, color:d.color, border:`1px solid ${d.color}40` }}>
                {d.badge}
              </span>
              {d.id === "detective" && (
                <span style={{
                  position:"absolute", bottom:"5px", right:"5px",
                  fontFamily:"'Space Mono',monospace", fontSize:"0.38rem",
                  letterSpacing:"0.06em", textTransform:"uppercase",
                  background:"rgba(250,204,21,0.12)", color:"#facc15",
                  border:"1px solid rgba(250,204,21,0.3)", borderRadius:"3px",
                  padding:"1px 4px", lineHeight:1.4,
                }}>★ default</span>
              )}
              <div className="diff-dot" style={{ background: d.color }} />
              <span className="diff-name" style={{ color: difficulty === d.id ? d.color : "var(--text)" }}>
                {d.label}
              </span>
              <span className="diff-desc">{d.desc}</span>
              <span className="diff-hints" style={{ color: d.color }}>{d.hints}</span>
            </button>
          ))}
        </div>

        {/* Active difficulty example */}
        {activeDiff && (
          <p style={{
            fontFamily:"'Space Mono',monospace", fontSize:"0.58rem",
            color:"var(--muted)", marginTop:"0.45rem", textAlign:"center",
            letterSpacing:"0.03em", lineHeight:1.5,
          }}>
            Example anomaly:&nbsp;
            <span style={{ color: activeDiff.color, fontStyle:"italic" }}>
              {activeDiff.example}
            </span>
          </p>
        )}

        {/* ── Custom page count ── */}
        <div className="custom-pages-row">
          <span className="custom-pages-label">
            Pages:&nbsp;
            <span style={{ color:"var(--gold)", fontWeight:700 }}>{finalPages}</span>
            &nbsp;(default for {activeDiff?.label})
          </span>
          <input
            className="custom-pages-input"
            type="number"
            min={1} max={20}
            placeholder="override"
            value={customPages}
            onChange={(e) => setCustomPages(e.target.value)}
          />
        </div>

        {/* ── Fun Mode ── */}
        <div className="custom-pages-row" style={{ marginTop:"0.55rem" }}>
          <span className="custom-pages-label">Fun Mode:</span>
          <label className="toggle-wrap" style={{ transform:"translateY(1px)" }}>
            <input
              type="checkbox"
              checked={funMode}
              onChange={(e) => setFunMode(e.target.checked)}
            />
            <span className="toggle-track" />
          </label>
          <span style={{
            fontFamily:"'Space Mono',monospace",
            fontSize:"0.56rem",
            color:"var(--muted)",
            maxWidth:260,
            lineHeight:1.35,
            textAlign:"left",
          }}>
            Unlimited hints, no cooldown, unranked score
          </span>
        </div>
        {customPages && !validCustom && (
          <p style={{ fontFamily:"'Space Mono',monospace", fontSize:"0.58rem", color:"#f87171", marginTop:"0.2rem", textAlign:"center" }}>
            Enter a number between 1 and 20
          </p>
        )}

        <hr className="start-section-divider" style={{ marginTop:"1.1rem" }} />

        {/* ── Buttons ── */}
        <div className="btn-row">
          <button className="btn btn-secondary" onClick={() => setOverlay("rules")}>📖 How to Play</button>
          <button className="btn btn-primary" onClick={handleStart} disabled={!canStart || (customPages && !validCustom)}>
            Begin Hunt →
          </button>
          <button className="btn btn-secondary" onClick={() => setOverlay("settings")}>⚙ Settings</button>
        </div>

      </div>

      {overlay === "rules"    && <RulesOverlay onClose={() => setOverlay(null)} />}
      {overlay === "settings" && <SettingsOverlay settings={settings} onChange={(id,v) => setSettings((s) => ({...s,[id]:v}))} onClose={() => setOverlay(null)} />}
    </div>
  );
}
